import { Form } from 'semantic-ui-react';
// import FilterAndSortCfgV2 from '../../../../components/financialTables/configuration/filterAndSortConfigV2';
// import TableAndP2pConfigV2 from '../../../../components/financialTables/configuration/tableAndP2pConfigV2';
import { ConfigProps } from '../../../../components/financialTables/configuration/constants';
import ComparisonConfigForm from '../comparisonConfigForm';
import {
    useComparisonFilterCfg,
    useComparisonTableConfig,
    useComparisonConfigActions,
} from '../../context';

function ConfigForm() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filterCfg = useComparisonFilterCfg() as any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tableConfig = useComparisonTableConfig() as any;
    const { setFilterCfg, setTableConfig } = useComparisonConfigActions();

    return (
        <Form size="mini">
            <ComparisonConfigForm
                filterCfg={filterCfg}
                tableConfig={tableConfig}
                onFilterChange={(cfg: Record<string, unknown>) => setFilterCfg(cfg)}
                onTableConfigChange={(cfg: Record<string, unknown>) => setTableConfig(cfg)}
                granularPeriodsFiltering={tableConfig[ConfigProps.GRANULAR_PERIODS_FILTERING]}
            />
            {/* <FilterAndSortCfgV2
                config={filterCfg}
                advancedConfig={tableConfig}
                onAdvancedChange={(cfg: Record<string, unknown>) => setTableConfig(cfg)}
                onChange={(cfg: Record<string, unknown>) => setFilterCfg(cfg)}
                granularPeriodsFiltering={tableConfig[ConfigProps.GRANULAR_PERIODS_FILTERING]}
            />
            {filterCfg[ConfigProps.SHOW_ADVANCED_SETTINGS] && (
                <TableAndP2pConfigV2
                    tableConfig={tableConfig}
                    onTableConfigChange={(cfg: Record<string, unknown>) => setTableConfig(cfg)}
                    chartsRef={null}
                />
            )} */}
        </Form>
    );
}

export default ConfigForm;
